<template lang="pug">
    div.locker-editor-control
        div.locker-editor-control__head
            div Content Locker

        post-file-upload-control.form-group(v-model='thumbnailImages' group='locker-thumbnail' mode='grid' :single='true' ref="uploadControl")

        re-checkboxes(v-model='lockerType' :options='lockerTypeOptions' :useArrayOptions='true')

        input-box-field(v-if='lockerTypeOnePayment' label='Price' v-model='price' type='number' unit='$')
        tag-box-field(v-if='lockerTypeSubscription' label='Choose Subscription' v-model='subscriptions' :whitelist='subscriptionOptions')
</template>

<script>
import EventBus from '../../lib/event-bus'
import Events from '../../lib/events'
import ModalsList from '../modals/modals-list'
export default {
    name: 'locker-editor-control',
    props: {
        value: {
            type: Object,
        },
        userSubscriptionProducts: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            thumbnailImages: [],
            lockerType: [],
            price: null,
            subscriptions: [],
        }
    },
    computed: {
        lockerTypeOptions() {
            return [
                { value: 'one-time-payment', label: 'One-time payment' },
                { value: 'subscription', label: 'Subscription' },
            ]
        },
        subscriptionOptions() {
            return this.userSubscriptionProducts.map(s => ({
                value: s.id,
                name: s.title,
            }))
        },

        lockerTypeOnePayment() {
            return this.lockerType.includes('one-time-payment')
        },
        lockerTypeSubscription() {
            return this.lockerType.includes('subscription')
        },
    },
    watch: {
        value: {
            handler() {
                this.updateFromProp()
            },
            deep: true,
        },
    },
    methods: {
        updateFromProp() {
            const d = this.value || {}

            this.thumbnailImages = []
            if (d.thumbnailImage) {
                this.thumbnailImages.push(d.thumbnailImage)
            }
            this.$refs.uploadControl.setFiles(this.thumbnailImages)

            this.lockerType = d.lockerType || ['one-time-payment']
            this.price = d.price
            this.subscriptions = d.subscriptions?.filter(s => this.userSubscriptionProducts.some(p => p.id == s))
                .map(s => ({
                    value: s,
                    name: this.userSubscriptionProducts.find(p => p.id == s).title,
                }))
        },

        apply() {
            if (this.$refs.uploadControl.checkUploadActive()) {
                EventBus.$emit(Events.OPEN_MODAL, ModalsList.GENERIC_INFO, {
                    text: 'Media is uploading, please wait.'
                })
                return
            }

            let invalid = false
            let lockerType = [...this.lockerType]
            const price = parseFloat(this.price)

            if (!this.validateLockerType(lockerType, 'one-time-payment', () => price)) {
                invalid = true
            }
            if (!this.validateLockerType(lockerType, 'subscription', () => this.subscriptions?.length)) {
                invalid = true
            }
            if (!lockerType.length) {
                invalid = true
            }

            const approve = () => {
                const val = lockerType.length ? {
                    thumbnailImage: this.thumbnailImages[0],
                    lockerType,
                    price,
                    subscriptions: this.subscriptions?.map(s => s.value),
                } : null
                
                this.$emit('input', val)
                this.$emit('change', val)
            }

            if (invalid) {
                EventBus.$emit(Events.OPEN_MODAL, ModalsList.GENERIC_CONFIRMATION, {
                    text: 'Payment options for content locker are not set. Are you sure you want to save it?',
                    approve,
                })
            }
            else {
                approve()
            }
        },

        validateLockerType(lockerType, type, validator) {
            if (!lockerType.includes(type)) {
                return true
            }

            if (validator()) {
                return true
            }

            lockerType.splice(lockerType.indexOf(type), 1)
        },
    },
    mounted() {
        this.updateFromProp()
    },
}
</script>
